export const calcBiasedRandomNbr  = (min, max, bias, influence) => {
    //  influence recommended to be set to .75 -->  this seems most even distribution of other numbers but
    //  definitely 'biased' toward the bias number.
    var rnd = 0;
    var mix = 0;
    rnd = (Math.random() * (+max - +min)) + +min  // random in range
    mix = Math.random() * influence;           // random mixer
    let randomNbr = (rnd * (1 - mix) + bias * mix).toFixed(0);
    return randomNbr;
}